module.exports = __webpack_public_path__ + "img/motive.b800160a.svg";